/**
 * src/shared/config/version.ts — canonical version source of truth
 *
 * MER Algo Footprints v9.2.0 — Global Trading HUD + Timeframe Support
 *
 * Release framing:
 *   v9.2.0 ships two related feature releases together: the Phase 2
 *   persistent Global Trading Header (HUD) across all authenticated
 *   routes, and the Phase 3 timeframe + horizon awareness layer
 *   (chart pill strip, trader horizon dropdown, AI thesis expiry
 *   strip, cross-device user_prefs persistence). Together they give
 *   the trader continuous market context plus an explicit walk-away
 *   contract on every AI thesis.
 *
 * Architecture milestone:
 *   - State Transition Engine: deterministic 10-state taxonomy (v1.0) [unchanged]
 *   - Outcome Attribution Layer: Closed-Loop Attribution Base [unchanged]
 *   - Attribution Analytics: confidence/quality/flag bucket summaries [8.1.0]
 *   - Transition Analytics: sequence extraction, next-state summaries [8.1.0]
 *   - Operator Guidance Engine: evidence-backed stance + messages [8.1.1]
 *   - Edge Intelligence Panel: renders evidence chain directly [8.1.1]
 *   - Learning Layer: v7.1H decision snapshot + AI review pipeline [unchanged]
 *   - SaaS Foundation: session auth + normalized user model [9.0]
 *   - Market Data: ThetaData Gateway/Terminal architecture [9.0]
 *   - Gamma v2: ThetaData chain-state engine, secondary and bounded [9.1]
 *   - Volatility Context: VIX regime service [9.1]
 *   - Global Trading HUD: persistent header across all routes [9.2 / Phase 2]
 *   - Timeframe Support: chart pills + trader horizon + thesis expiry [9.2 / Phase 3]
 *   - User Prefs: Postgres-backed cross-device persistence [9.2]
 *   - CI: check:version → check → build:verify → validate →
 *         test:equivalence → test:learning → test:state-transition →
 *         test:attribution → test:edge
 *
 * CORE MISSION (non-negotiable):
 *   Non-executing AI intraday decision support system.
 *   Price action / structure / liquidity are primary.
 *   Gamma remains secondary and bounded.
 *   All intelligence is deterministic, auditable, and decision-support only.
 */
export const APP_VERSION  = '9.2.0' as const;
export const APP_TITLE    = 'MER Algo Footprints' as const;
export const APP_FULL     = `${APP_TITLE} v${APP_VERSION}` as const;
export const APP_RELEASE  = 'Global Trading HUD + Timeframe Support' as const;
export const APP_PHASE    = 'v9.2.0 — Phase 2 (Persistent HUD) + Phase 3 (Timeframe / Horizon / Thesis Expiry)' as const;
